module.exports = __webpack_public_path__ + "static/media/verdanai.312cc11e.woff";